export const GIT_COMMIT = 'cfabcbaa8c840b15e1f977a835732818a8509620'
